module.exports = __webpack_public_path__ + "img/bnr_popup.974c9cff.jpg";